import { useQuery } from '@apollo/client';
import { SAVED_SEARCHES_QUERY } from '@general/graphql/saved-searches.graph';

const useSavedSearches = options => useQuery(SAVED_SEARCHES_QUERY, options);

export default useSavedSearches;
